import React, { useState, useEffect, useMemo } from 'react';
import axiosInstance from './backend/axiosInstance';
import { motion } from "framer-motion";
import { data, Link } from 'react-router-dom';
import { LeagueIcons, LeaugeIconsInvert } from './data/LeagueIcons';
import { TeamIconComponent } from './data/TeamIcons';
import { AgentIcons } from './data/AgentIcons';
import AgentCustomSelect from './selects/AgentCustomSelect';
import MapCustomSelect from './selects/MapCustomSelect1';
import TeamCustomSelect from './selects/TeamCustomSelect';
import PatchCustomSelect from './selects/PatchCustomSelect';
import LeagueCustomSelect from './selects/LeagueCustomSelect';
import CustomSelect from './selects/CustomSelect';
import { Maps, MapsData } from './data/MapIcons';


const RoundFinderComponent = () => {
    const [selectedRound, setSelectedRound] = useState(null);
    const [roundTime, setRoundTime] = useState(0);
    const [playing, setPlaying] = useState(false);
    const [roundData, setRoundData] = useState(null);

    const [minTime, setMinTime] = useState(-40);
    const [maxTime, setMaxTime] = useState(200);

    const mapSize = 700;

    const [selectedAgents, setSelectedAgents] = useState([]);
    const [filterAgents, setFilterAgents] = useState([]);

    const [selectedMap, setSelectedMap] = useState("Ascent");

    const [selectedPatch, setSelectedPatch] = useState([]);
    const [filterPatch, setFilterPatch] = useState([]);
    const [patchOption, setPatchOption] = useState([]);

    const [selectedDeffender, setSelectedDeffender] = useState([]);
    const [filterDeffender, setFilterDeffender] = useState([]);
    const [deffenderOption, setDeffenderOption] = useState([]);

    const [selectedAttacker, setSelectedAttacker] = useState([]);
    const [filterAttacker, setFilterAttacker] = useState([]);
    const [attackerOption, setAttackerOption] = useState([]);

    const [selectedDeffenderEconomy, setSelectedDeffenderEconomy] = useState([]);
    const [filterDeffenderEconomy, setFilterDeffenderEconomy] = useState([]);
    const deffenderEconomyOption = [
        { value: "pistols", label: "Pistols" },
        { value: "1", label: "0-5k" },
        { value: "2", label: "5-10k" },
        { value: "3", label: "10-20k" },
        { value: "4", label: "20k+" },
    ];

    const [selectedAttackerEconomy, setSelectedAttackerEconomy] = useState([]);
    const [filterAttackerEconomy, setFilterAttackerEconomy] = useState([]);
    const attackerEconomyOption = [
        { value: "pistols", label: "Pistols" },
        { value: "1", label: "0-5k" },
        { value: "2", label: "5-10k" },
        { value: "3", label: "10-20k" },
        { value: "4", label: "20k+" },
    ];


    const [selectedLeague, setSelectedLeague] = useState([]);
    const [filterLeague, setFilterLeague] = useState([]);
    const [leagueOption, setLeagueOption] = useState([]);

    useEffect(() => {
        axiosInstance
            .get(`unique_teames/`)
            .then(response => {
                const formattedTeamOptions = response.data
                    .sort((a, b) => a.localeCompare(b))
                    .map((t) => ({ value: t, label: t }));
                setAttackerOption(formattedTeamOptions);
                setDeffenderOption(formattedTeamOptions);

            })
            .catch(error => {
                console.error(error);
            });
    }, []);

    const handleAgentChange = (selectedOptions) => {
        const agentValues = selectedOptions.map((option) => option.value);
        setFilterAgents(agentValues);
        setSelectedAgents(selectedOptions);
    };


    const handleMapChange = (option) => {
        setSelectedMap(option.value);
    };

    const handleDeffenderChange = (selectedOptions) => {
        const leagueValues = selectedOptions.map((option) => option.value);
        setFilterDeffender(leagueValues);
        setSelectedDeffender(selectedOptions);
    };

    const handleAttackerChange = (selectedOptions) => {
        const leagueValues = selectedOptions.map((option) => option.value);
        setFilterAttacker(leagueValues);
        setSelectedAttacker(selectedOptions);
    };

    const handleDeffenderEconomyChange = (selectedOptions) => {
        const leagueValues = selectedOptions.map((option) => option.value);
        setFilterDeffenderEconomy(leagueValues);
        setSelectedDeffenderEconomy(selectedOptions);
    };

    const handleAttackerEconomyChange = (selectedOptions) => {
        const leagueValues = selectedOptions.map((option) => option.value);
        setFilterAttackerEconomy(leagueValues);
        setSelectedAttackerEconomy(selectedOptions);
    };


    const handlePatchChange = (selectedOptions) => {
        const leagueValues = selectedOptions.map((option) => option.value);
        setFilterPatch(leagueValues);
        setSelectedPatch(selectedOptions);
    };

    const handleLeagueChange = (selectedOptions) => {
        const leagueValues = selectedOptions.map((option) => option.value);
        setFilterLeague(leagueValues);
        setSelectedLeague(selectedOptions);
    };

    const convertToMapPosition = (gameX, gameY, map, width, height) => {
        const {
            xMultiplier,
            yMultiplier,
            xScalarToAdd,
            yScalarToAdd
        } = map;

        let x = gameY * xMultiplier + xScalarToAdd;
        let y = gameX * yMultiplier + yScalarToAdd;

        return {
            x: x * width,
            y: y * height
        };
    };

    useEffect(() => {
        if (!playing || !roundData) return;

        const interval = setInterval(() => {
            setRoundTime(prev => {
                const round = roundData[selectedRound];
                const maxTime = Math.max(
                    ...Object.values(round.players)
                        .flatMap(p => p.positions.map(pos => pos.time))
                );

                if (prev >= maxTime) {
                    clearInterval(interval);
                    return prev;
                }

                return prev + 100;
            });
        }, 100);

        return () => clearInterval(interval);
    }, [playing, selectedRound, roundData]);

    const getCurrentPositions = (round, currentTime) => {
        const result = {};

        Object.entries(round.players).forEach(([name, player]) => {
            const positions = player.positions;

            let last = positions[0];

            for (let i = 0; i < positions.length; i++) {
                if (positions[i].time == currentTime) {
                    last = positions[i];
                }
            }

            result[name] = {
                ...player,
                current: last
            };
        });

        return result;
    };

    const findRounds = async () => {
        try {
            const response = await axiosInstance.post("roundfinder/", {
                attackerteams: filterAttacker,
                defenderteams: filterDeffender,
                attackereco: filterAttackerEconomy,
                deffendereco: filterDeffenderEconomy,
                maps: [selectedMap],
            });

            const normalized = normalizePerPlayer(response.data);

            setRoundData(normalized);
            setSelectedRound(0);
            setRoundTime(0);
        } catch (error) {
            console.error(error);
        }
    };

    const normalizePerPlayer = (data) => {
        return data.map(round => {

            const normalizedPlayers = {};
            let min = 200
            let max = -40
            Object.entries(round.players).forEach(([name, player]) => {

                if (!player.positions.length) return;

                const sorted = [...player.positions].sort((a, b) => a.time - b.time);

                const startTime = sorted.filter((a) => a.roundStatus == "in_round")[0].time;

                const normalizedPositions = sorted.map(p => {
                    const normalizedTime = p.time - startTime;

                    min = Math.min(min, normalizedTime);
                    max = Math.max(max, normalizedTime);

                    return {
                        ...p,
                        time: normalizedTime,
                        agent: player.agent
                    };
                });

                normalizedPlayers[name] = {
                    ...player,
                    positions: normalizedPositions
                };
            });

            setMaxTime(max)
            setMinTime(min)

            return {
                ...round,
                players: normalizedPlayers
            };
        });
    };

    const rounds = roundData || [];



    return (
        <div style={{ display: 'flex', flexDirection: "column", alignItems: "center", color: 'white' }}>
            <div className='filters'>
                <div className='short-chooser' style={{ width: "150px" }}>
                    <MapCustomSelect selectedOption={selectedMap} onOptionChange={handleMapChange} />
                </div>
                <div className='short-chooser' style={{ width: "150px" }}>
                    <PatchCustomSelect options={patchOption} selectedOption={selectedPatch} onOptionChange={handlePatchChange} />
                </div>
                <div className='short-chooser'>
                    <LeagueCustomSelect options={leagueOption} selectedOption={selectedLeague} onOptionChange={handleLeagueChange} />
                </div>
                <div className='short-chooser'>
                    <TeamCustomSelect placeholder={"Attacker"} options={attackerOption} selectedOption={selectedAttacker} onOptionChange={handleAttackerChange} />
                </div>
                <div className='short-chooser' style={{ width: "150px" }}>
                    <CustomSelect placeholder={"ATK ECO"} options={attackerEconomyOption} selectedOption={selectedAttackerEconomy} onOptionChange={handleAttackerEconomyChange} />
                </div>
                <div className='short-chooser'>
                    <TeamCustomSelect placeholder={"Deffender"} options={deffenderOption} selectedOption={selectedDeffender} onOptionChange={handleDeffenderChange} />
                </div>
                <div className='short-chooser' style={{ width: "150px" }}>
                    <CustomSelect placeholder={"DEF ECO"} options={deffenderEconomyOption} selectedOption={selectedDeffenderEconomy} onOptionChange={handleDeffenderEconomyChange} />
                </div>
                <div className='short-chooser'>
                    <AgentCustomSelect selectedOption={selectedAgents} onOptionChange={handleAgentChange} />
                </div>
                <button style={{ margin: '10px' }} className="button-dark" onClick={findRounds}>{"FIND"}</button>


            </div>

            <div style={{ position: "relative", width: mapSize, height: mapSize }}>
                <img
                    src={Maps[selectedMap]?.minimap}
                    style={{ width: mapSize, height: mapSize, position: "absolute" }}
                />

                {rounds.map((round, idx) => {
                    const players = getCurrentPositions(round, roundTime);
                    return (
                        <div key={idx}>
                            {Object.entries(players).map(([name, p]) => {
                                const pos = convertToMapPosition(
                                    p.current.x,
                                    p.current.y,
                                    MapsData.Ascent,
                                    mapSize,
                                    mapSize
                                ); return (
                                    <div
                                        key={name + idx}
                                        style={{
                                            position: "absolute",
                                            left: pos.x,
                                            top: pos.y,
                                            width: 16,
                                            height: 16,
                                            borderRadius: "50%",
                                            background: "black",
                                            opacity: 0.7,
                                            transform: "translate(-50%, -50%)"
                                        }}
                                        title={`Round ${round.roundNumber} - ${name}`}
                                    >
                                        <img src={AgentIcons[p.agent]} style={{ position: "fixed", width: '100%', height: "100%", borderRadius: "50%" }} />
                                    </div>
                                )
                            })}
                        </div>
                    );
                })}
            </div>
            <input
                type="range"
                min={minTime}
                max={maxTime}
                value={roundTime}
                onChange={(e) => setRoundTime(Number(e.target.value))}
            />
            {roundTime}
        </div>

    );
}



export default RoundFinderComponent;
